import type { ReactNode } from "react";

/** A surface card — the `fawkes-form-card` vocabulary from docs/ui-conventions.md. */
export function FormCard({ children }: { children: ReactNode }) {
  return <section className="fui-card">{children}</section>;
}
